import { Box } from 'lucid-components-react';
import React from 'react';

import LucidContainer from 'components/lucid-container/lucid-container';
import { Drupal_ParagraphQuote } from 'generated/graphql';
import { mqMax } from 'theme/base';
import { Text } from 'theme/typography';
import { LucidTheme } from 'types/types';

interface Props {
  quote?: Drupal_ParagraphQuote;
}

const Quote = ({ quote }: Props) => {
  if (!quote) {
    return null;
  }
  return (
    <LucidContainer as="section">
      <Box
        css={(theme: LucidTheme) => ({
          justifyContent: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          maxWidth: '80%',
          margin: '0 auto',
          [mqMax.tabletSmall]: {
            padding: `${theme.space[9]}px ${theme.space[0]} ${theme.space[8]}px`
          }
        })}
        py={10}
      >
        <blockquote
          css={(theme: LucidTheme) => ({
            display: 'flex',
            position: 'relative',
            justifyContent: 'center',
            flexWrap: 'wrap',
            [mqMax.tabletSmall]: {
              maxWidth: '80%',
              flex: '0 1 80%',
              left: '-1rem'
            },
            '&::before': {
              content: '"\\201C"',
              left: '-6rem',
              top: 0
            },
            '&::before, &::after': {
              font: '400 10rem serif',
              color: theme.colors.orange[20],
              position: 'absolute',
              display: 'inline',
              lineHeight: 0
            },
            '&::after': {
              content: '"\\201D"',
              right: '-4rem',
              bottom: '-1rem',
              [mqMax.tabletSmall]: {
                right: '-1rem',
                bottom: '-3rem'
              }
            }
          })}
        >
          <Box css={{ flex: '0 1 100%', maxWidth: '100%' }}>
            <Text textStyles="quoteM">{quote.fieldQuote}</Text>
          </Box>
          <Box
            css={(theme: LucidTheme) => ({
              flex: '0 1 100%',
              maxWidth: '100%',
              fontSize: theme.fontSizes[3],
              fontWeight: theme.fontWeights.subheading
            })}
          >
            {quote.fieldAttribution}
          </Box>
        </blockquote>
      </Box>
    </LucidContainer>
  );
};

export default Quote;
